<template>
  <div-box>
    <wallet-head show_type="9" />
    <div-padding padding="10vw 4vw">
      <div-input>
        <div-card bg='#242424' padding='3vw' radius='2vw'>
          <van-field :border='false' type="password" clearable v-model='old_password' :placeholder='$t("请输入旧密码")'>
          </van-field>
        </div-card>
      </div-input>
      <div-height height='4vw' />
      <div-input>
        <div-card bg='#242424' padding='3vw' radius='2vw'>
          <van-field :border='false' type="password" clearable v-model='password' :placeholder='$t("请输入新密码")'>
          </van-field>
        </div-card>
      </div-input>
      <div-height height='4vw' />
      <div-input>
        <div-card bg='#242424' padding='3vw' radius='2vw'>
          <van-field :border='false' type="password" clearable v-model='password_to' :placeholder='$t("请确认新密码")'>
          </van-field>
        </div-card>
      </div-input>
      <div-height height='50vw' />
      <div-btn @click.native="tran()" radius="3vw" bg="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)">
        <div-text color='#242424' blod size='4vw'>{{ $t('确定') }}</div-text>
      </div-btn>
    </div-padding>

  </div-box>
</template>
<script>
  export default {
    data() {
      return {
        old_password: "",
        password: "",
        password_to: "",
      }
    },
    created() { },
    methods: {
      tran() {
        if (!this.old_password) return this.$toast(this.$t("请输入旧密码"))
        if (!this.password) return this.$toast(this.$t("请输入新密码"))
        if (!this.password_to) return this.$toast(this.$t("请确认新密码"))
        this.$post({
          url: "/api/v1/user/trade_password",
          data: {
            old_password: this.old_password,
            trade_password: this.password,
            trade_password_confirmation: this.password_to,
          },
          success: (res) => {
            this.$toast(this.$t("修改成功"))
            this.password = ""
            this.password_to = ""
          },
          tip: () => { },
        })
      },
    },
  }
</script>
<style lang='less' scoped>
  /deep/.van-field__control {
    color: #fff !important;
    font-size: 4vw !important;
  }
  /deep/.van-field__label {
    color: #999 !important;
    font-size: 4vw !important;
  }
</style>